<div id="wrapper">
    <div>
        <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
    </div>
    <div>
        <app-tab-nav [visible]="false" (updatePostpaid)="this.postpago=$event" (updatePrepaid)="this.prepago=$event"
            (updateFixed)="this.telefoniaFijo=$event" (updateTotalAccountList)="this.totalAccountList=$event"
            (updateCurrentList)="this.currentList=$event" (updateSelectBan)="this.selectBan=$event"
            (updateInitializeData)="this.initializeData()"></app-tab-nav>
    </div>
    <div class="allcont logsize m-top-notif">
        <div class="basicrow mbott p-bot">
            <div class="container">
                <div class="fulltitle  f-btitle autodef">
                    <span class="icon-dash-12"></span> Tus Notificaciones
                </div>
                <div class="basicrow">
                    <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-12 " *ngIf="this.id!=-1">
                            <div class="autowcont m-top-i">
                                <div class="basicrow msidespad">
                                    <div class="b-title">
                                        <div class="autocont f-black roboto-m f-bmed pull-left vcenter">
                                            <div class="tabcell">
                                                {{this.Message.subject}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="basicrow m-bott-i">
                                        <div class="basicrow" [innerHTML]="this.Message.message | safeHtml">
                                            
                                        </div>

                                        <div class="basicrow roboto-b m-top-u-ii f-bgray">
                                            {{this.Message.message_date}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ng-container *ngIf="this.id==-1">
                            <div class="col-xs-12 col-sm-12 col-md-12" *ngFor="let message of this.Messages; let i = index">
                                <div class="autowcont m-top-i">
                                    <div class="basicrow msidespad">
                                        <div class="b-title">
                                            <div class="autocont f-black roboto-m f-bmed pull-left vcenter">
                                                <div class="tabcell">
                                                    {{message.subject}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="basicrow m-bott-i">
                                            <div class="basicrow" [innerHTML]="message.message | safeHtml">
                                            </div>
                                            <div class="basicrow roboto-b m-top-u-ii f-bgray">
                                                {{message.message_date}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>